import features from './features.json';

export function isOrdersEnabled() {
  return Boolean(features.orders);
}

/** Admin GUI: marker telefon innlogget (kan skrus av etter testperiode). */
export function isManualPhoneLogonEnabled() {
  return Boolean(features.manualPhoneLogon);
}

/** Admin GUI: marker telefon avlogget (samme pipeline som Auto Logout / MobilLogoff). */
export function isManualPhoneLogoffEnabled() {
  return Boolean(features.manualPhoneLogoff);
}
